import React from "react";
import { useNavigate } from "react-router-dom";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import Table from "common-ui-components/components/table/Table";
import InfoBoxRedirectButton from "app/common/InfoBoxRedirectButton";
import styles from "./ThreatsDashboardPanels.module.css";

const normalize = (value) => String(value || "").trim().toLowerCase();

const PortAuditPanel = ({ data }) => {
  const navigate = useNavigate();
  const columns = [
    { title: "Port", accessor: "portNumber" },
    {
      title: "Type",
      accessor: "portType",
      WrapperComponent: ({ record, children }) => (
        <span className={`${styles.portType} ${styles[normalize(record.portType)]}`}>
          {children}
        </span>
      ),
    },
    {
      title: "Risk",
      accessor: "risk",
      WrapperComponent: ({ record, children }) => (
        <span className={`${styles.severity} ${normalize(record.risk).includes("risky") ? styles.critical : styles.medium}`}>
          {children}
        </span>
      ),
    },
    { title: "Instances", accessor: "instances" },
  ];

  return (
    <InfoBox
      header="Port Audit"
      subtitle="Open ports detected on managed endpoints"
      badge={
        <InfoBoxRedirectButton
          onClick={() => navigate("/app/secure/threats/port-audit/summary")}
          label="View all port audit results"
        />
      }
      badgeProps={{ className: styles.viewAllBadge }}
      className={styles.panel}
      childrenProps={{ className: styles.tableContent }}
    >
      <div className={styles.tableViewport}>
        <Table
          columns={columns}
          records={data.records}
          total={data.loading ? null : data.total}
          skeletonRowCount={5}
          borders={{ borderRadius: "0.75rem", borderColor: "#e2e8f0" }}
          cellPadding="0.8rem"
        />
      </div>
    </InfoBox>
  );
};

export default PortAuditPanel;
